module.exports = __webpack_public_path__ + "4abfa525f7ebb0cdc6815652202c3209.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/hootagotchi.png
// module id = 2049
// module chunks = 0